/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-useless-escape */
import { useEffect, useState, useCallback, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Button, Input, Select, DatePicker } from "components/core";
import { PageWrapper } from "components";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { useHistory } from "react-router-dom";
import {
  STATES,
  curpRegExp,
  phoneRegExp,
  GENDERS,
  REGISTER,
} from "constants/index";
import { fetchBackend } from "helpers";

import iconVaccine from "assets/images/auth/icons/icon-vaccine.svg";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import moment from "moment";

const SchemaCurp = yup.object().shape({
  curp: yup
    .string()
    .matches(curpRegExp, "curp ingresada no es válida")
    .required("Ingresa tu curp"),
});

const SchemaVaccine = yup.object().shape({
  name: yup.string().required("Ingresa tu nombre"),
  fatherLastName: yup.string().required("Ingresa tu apellido paterno"),
  motherLastName: yup.string().required("Ingresa tu apellido materno"),
  address: yup.string().required("Ingresa la dirección"),
  city: yup.string().required("Ingresa la ciudad"),
  state: yup.string().required("Ingresa el estado"),
  cp: yup.string().required("Ingresa el código postal"),
  birthDay: yup.string().required("Ingresa tu fecha de nacimiento"),
  email: yup.string().required("Ingresa tu correo"),
  phoneNumber: yup
    .string()
    .length(10, "El número de teléfono debe tener 10 caracteres")
    .matches(phoneRegExp, "El número de teléfono no es válido"),
  gender: yup.string().required("Ingresa tu genero"),
});

const SchemaVaccineYoung = yup.object().shape({
  name: yup.string().required("Ingresa tu nombre"),
  fatherLastName: yup.string().required("Ingresa tu apellido paterno"),
  motherLastName: yup.string().required("Ingresa tu apellido materno"),
  address: yup.string().required("Ingresa la dirección"),
  city: yup.string().required("Ingresa la ciudad"),
  state: yup.string().required("Ingresa el estado"),
  cp: yup.string().required("Ingresa el código postal"),
  birthDay: yup.string().required("Ingresa tu fecha de nacimiento"),
  gender: yup.string().required("Ingresa tu genero"),
});

const Vaccines = ({ setLoading }) => {
  const [dataSource, setDataSource] = useState([]);
  const [isCompletedForm, setCompletedForm] = useState(false);
  const [isComingSoon, setComingSoon] = useState(false);
  const gContext = useGlobalContext();

  const getVaccine = useCallback(async () => {
    const id = gContext.currentUser._id;
    const { error, response } = await fetchBackend({
      url: `vaccine/user/all/${id}`,
    });

    if (!error) {
      setCompletedForm(response.length > 0);
      setDataSource(response);
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar obtener la información, revisa tu conexión a internet",
        type: "error",
      });
    }
  }, [gContext.currentUser]);

  const getInitialState = useCallback(async () => {
    const id = gContext.currentUser._id;
    if (id) {
      await Promise.all([getVaccine()]);
      setLoading(false);
    }
  }, [gContext.currentUser]);

  useEffect(() => {
    getInitialState();
  }, []);

  if (isComingSoon) {
    return (
      <PageWrapper
        header={
          <Row start="xs">
            <Col md={12}>
              <Row center="xs">
                <h1>Programa de vacunación</h1>
              </Row>
            </Col>
          </Row>
        }
      >
        <ComingSoonVaccine />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper
      header={
        <Row start="xs">
          <Col md={12}>
            <Row center="xs">
              <h1>Programa de vacunación</h1>
            </Row>
          </Col>
        </Row>
      }
    >
      <>
        {isCompletedForm ? (
          <PageListVaccine dataSource={dataSource} status="En espera" />
        ) : (
          <FormVaccine />
        )}
      </>
    </PageWrapper>
  );
};

export default withLoader(Vaccines, "Cargando vacunas");

const FormVaccine = ({ data = {}, isYoung, isViewList }) => {
  const [currentCurp, setCurp] = useState("");
  const [isChargin, setCharge] = useState(false);
  const [currentStep, setStep] = useState(0);
  const gContext = useGlobalContext();
  const history = useHistory();
  const curpRef = useRef("");

  const {
    handleSubmit,
    register,
    errors,
    control,
    setValue,
    setError,
  } = useForm({
    resolver: yupResolver(isYoung ? SchemaVaccineYoung : SchemaVaccine),
  });

  const onSendViewRegister = async () => {
    const curp = curpRef.current.value.trim().toUpperCase();
    const isValidate = await SchemaCurp.isValid({ curp });
    if (isValidate) {
      setCurp(curp);
      setStep((s) => s + 1);
    } else {
      setError("curp", {
        type: "regex",
        message: "curp ingresada no es válida",
      });
    }
  };

  const generateCurp = ({
    name,
    fatherLastName,
    motherLastName,
    state,
    birthDay,
    gender,
  }) => {
    const date = moment(birthDay).format("L");
    const CURP = [];
    CURP[0] = fatherLastName.charAt(0).toUpperCase();
    CURP[1] = fatherLastName
      .slice(1)
      .replace(/\a\e\i\o\u/gi, "")
      .charAt(0)
      .toUpperCase();
    CURP[2] = motherLastName.charAt(0).toUpperCase();
    CURP[3] = name.charAt(0).toUpperCase();
    CURP[4] = date.toString().slice(-2);
    CURP[5] = date.slice(3, 5);
    CURP[6] = date.slice(0, 2);
    CURP[7] = gender;
    CURP[8] = state;
    CURP[9] = fatherLastName
      .slice(1)
      .replace(/[aeiou]/gi, "")
      .charAt(0)
      .toUpperCase();
    CURP[10] = motherLastName
      .slice(1)
      .replace(/[aeiou]/gi, "")
      .charAt(0)
      .toUpperCase();
    CURP[11] = name
      .slice(1)
      .replace(/[aeiou]/gi, "")
      .charAt(0)
      .toUpperCase();
    return CURP.join("");
  };

  const addRequestVaccine = async (obj) => {
    setCharge(true);
    const { error, response } = await fetchBackend({
      method: "post",
      url: "vaccine",
      data: obj,
    });

    if (!error) {
      setCharge(false);

      const id = response.data?.result._id;
      history.push(`/vacunas/pago/${id}`);
      gContext.toggleAlert({
        message: "Solicitud de vacuna registrada con exito",
      });
      // window.location.reload();
    } else {
      setCharge(false);
      const message =
        response.data?.error ||
        "Hubo un error al intentar registrar la solicitud, intente nuevamente";
      gContext.toggleAlert({
        message,
        type: "error",
      });
    }
  };

  const getVaccineCurrentUser = async () => {
    const { error, response } = await fetchBackend({
      url: `vaccine/user/${gContext.currentUser._id}`,
    });

    if (!error) {
      return response[0] || null;
    } else {
      const message =
        response.data?.error ||
        "Hubo un error al intentar obtener los datos, intente nuevamente";
      gContext.toggleAlert({
        message,
        type: "error",
      });

      return null;
    }
  };

  const onSubmit = useCallback(
    async ({
      name = "",
      fatherLastName = "",
      motherLastName = "",
      address = "",
      city = "",
      state = "",
      cp = "",
      birthDay = "",
      email = "",
      phoneNumber = "",
      gender = "",
    }) => {
      const obj = {
        name: name.toUpperCase(),
        fatherLastName: fatherLastName.toUpperCase(),
        motherLastName: motherLastName.toUpperCase(),
        address,
        city,
        state,
        cp,
        birthDay: new Date(birthDay).getTime(),
        email: email.toLowerCase(),
        phoneNumber,
        gender,
        curp: currentCurp.toUpperCase(),
        criterion: "",
        user: gContext.currentUser._id,
        dateCreated: new Date().getTime(),
        status: REGISTER,
      };

      const curpGenerated = generateCurp({ ...obj, birthDay });

      if (obj.curp.includes(curpGenerated)) {
        const isYoungUser =
          Math.abs(
            new Date(obj.birthDay).getFullYear() - new Date().getFullYear()
          ) < 18;

        // console.log(obj);
        // console.log(curpGenerated);

        if (!isViewList) {
          await addRequestVaccine({ ...obj, status: REGISTER });
        } else {
          const singleVaccineUser = await getVaccineCurrentUser();
          console.log("singleVaccineUser", singleVaccineUser);
          obj.rootUser = gContext.currentUser._id;
          const newObj = {
            ...obj,
            status: REGISTER,
            rootUser: gContext.currentUser._id,
            user: null,
          };

          console.log(newObj);

          if (obj.fatherLastName === singleVaccineUser?.fatherLastName) {
            if (obj.motherLastName === singleVaccineUser?.motherLastName) {
              if (isYoung) {
                if (isYoungUser) {
                  console.log("Es joven");
                  await addRequestVaccine(newObj);
                } else {
                  gContext.toggleAlert({
                    message:
                      "Los datos ingresador no son de una persona menor de edad, verifique su información",
                    type: "error",
                  });
                }
              } else {
                if (!isYoungUser) {
                  console.log("mayor de edad");
                  await addRequestVaccine(newObj);
                } else {
                  gContext.toggleAlert({
                    message:
                      "Los datos ingresador no son de una persona mayor de edad, verifique su información",
                    type: "error",
                  });
                }
              }
            } else {
              gContext.toggleAlert({
                message:
                  "El apellido materno del usuario ingresado no pertece a un familiar cercano",
                type: "error",
              });
            }
          } else {
            gContext.toggleAlert({
              message:
                "El apellido paterno del usuario ingresado no pertece a un familiar cercano",
              type: "error",
            });
          }
        }
      } else {
        gContext.toggleAlert({
          message:
            "Los datos ingresador no coinciden con la CURP, verifique su información",
          type: "error",
        });
      }
    },
    [gContext.currentUser, currentCurp]
  );

  useEffect(() => {
    if (currentStep === 1 && !isViewList) {
      const { name, phoneNumber, email } = gContext.currentUser;
      setValue("name", name);
      setValue("phoneNumber", phoneNumber);
      setValue("email", email);
    }
  }, [gContext.currentUser, currentStep]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="w-100">
        <>
          <Row
            middle="xs"
            className={`pt4 pt6-l ${currentStep === 0 ? "" : "dn"}`}
          >
            <Col md={12}>
              <Row center="xs">
                <Col md={12}>
                  <Typography variant="h4">COVID19</Typography>
                </Col>
                <img src={iconVaccine} alt="iconVaccine" className="m-auto" />
                <Input
                  md={12}
                  name="curp"
                  classMain="p0"
                  placeholder="CURP"
                  ref={curpRef}
                  disabled={isChargin}
                  error={errors.curp?.message}
                />
                <Col md={12} className="mt2">
                  <Button
                    color="primary"
                    size="large"
                    className="w-100"
                    onClick={onSendViewRegister}
                  >
                    Continuar
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className={currentStep === 1 ? "" : "dn"}>
            <Input
              md={12}
              name="name"
              placeholder="Nombre"
              ref={register}
              disabled={isChargin}
              error={errors.name?.message}
            />
            <Input
              md={12}
              name="fatherLastName"
              placeholder="Apellido paterno"
              ref={register}
              disabled={isChargin}
              error={errors.fatherLastName?.message}
            />
            <Input
              md={12}
              name="motherLastName"
              placeholder="Apellido materno"
              ref={register}
              disabled={isChargin}
              error={errors.motherLastName?.message}
            />
            <Select
              xs={12}
              md={12}
              name="gender"
              defaultValue={data?.gender}
              valueOption="_id"
              labelOption="title"
              placeholder="Sexo"
              label="Sexo"
              ref={register}
              disabled={isChargin}
              options={GENDERS}
              error={errors.gender?.message}
            />
            <Select
              xs={12}
              md={12}
              name="state"
              defaultValue={data?.state}
              valueOption="_id"
              labelOption="title"
              placeholder="Estado"
              label="Estado"
              ref={register}
              disabled={isChargin}
              options={STATES}
              error={errors.state?.message}
            />
            <Controller
              name="birthDay"
              control={control}
              defaultValue={
                data?.birthDay ? new Date(data?.birthDay) : new Date()
              }
              render={(props) => (
                <DatePicker
                  md={12}
                  theme="true"
                  label="Fecha de nacimiento"
                  value={props.value}
                  onChange={(date) => props.onChange(date)}
                  error={errors.birthDay?.message}
                />
              )} // props contains: onChange, onBlur and value
            />
            {/* <Input
            md={12}
            name="curp"
            placeholder="CURP"
            ref={register}
            disabled
            error={errors.curp?.message}
          /> */}
            <Input
              md={12}
              name="address"
              placeholder="Dirección"
              ref={register}
              disabled={isChargin}
              error={errors.address?.message}
            />
            <Input
              md={12}
              name="city"
              placeholder="Municipio"
              ref={register}
              disabled={isChargin}
              error={errors.city?.message}
            />
            <Input
              md={12}
              name="cp"
              type="number"
              placeholder="Código postal"
              ref={register}
              disabled={isChargin}
              error={errors.cp?.message}
            />
            <Input
              md={12}
              name="email"
              placeholder="Correo eléctronico"
              ref={register}
              disabled={isChargin}
              error={errors.email?.message}
            />
            <Input
              md={12}
              type="number"
              name="phoneNumber"
              placeholder="Número telefónico"
              ref={register}
              disabled={isChargin}
              error={errors.phoneNumber?.message}
            />
            <Col md={12} className="mt2">
              <Button
                htmlType="submit"
                color="primary"
                size="large"
                className="w-100"
                loading={isChargin}
              >
                Registrarme
              </Button>
            </Col>
          </Row>
        </>
      </form>
    </>
  );
};

const PageListVaccine = ({ dataSource }) => {
  const [isShowForm, setShowForm] = useState(false);
  const [isYoung, setYoung] = useState(false);
  const history = useHistory();

  const onEvent = (type) => {
    if (type === "young") {
      setYoung(true);
    } else {
      setYoung(false);
    }

    setShowForm(true);
  };

  return (
    <>
      {!isShowForm ? (
        <Row center="xs" middle="xs" className="w-100">
          <Col md={12}>
            <Row>
              <Col md={12}>
                <Row end="xs">
                  <Col md={12} className="mb3">
                    <List className="w-100">
                      {dataSource.map(
                        ({
                          name,
                          motherLastName,
                          fatherLastName,
                          curp,
                          status,
                          ...el
                        }) => {
                          return (
                            <ListItem
                              button
                              key={el._id}
                              onClick={() => history.push(`/vacunas/${el._id}`)}
                            >
                              <ListItemText
                                primary={`${name} ${fatherLastName} ${motherLastName}`}
                                secondary={`${curp} - ${status}`}
                              />
                              <ListItemSecondaryAction>
                                <ChevronRightIcon />
                              </ListItemSecondaryAction>
                            </ListItem>
                          );
                        }
                      )}
                    </List>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row center="xs" className="mt3 mb3">
              <Col md={6}>
                <Button
                  variant="contained"
                  color="primary"
                  className="w-100"
                  onClick={() => onEvent("young")}
                >
                  Registrar menor de edad
                </Button>
              </Col>
              <Col md={6}>
                <Button
                  variant="contained"
                  color="secondary"
                  className="w-100"
                  onClick={() => onEvent("old year")}
                >
                  Registrar mayor de edad
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        <FormVaccine isYoung={isYoung} isViewList />
      )}
    </>
  );
};

const ComingSoonVaccine = () => {
  return (
    <Row center="xs" middle="xs" className="w-100  pt6">
      <Col md={12} className="mt4">
        <Row center="xs">
          <img src={iconVaccine} alt="iconVaccine" className="m-auto" />
        </Row>
        <Row center="xs">
          <Typography variant="h6" color="secondary">
            Próximamente podrás realizar tu solicitud de vacuna desde la App de
            México Seguro
          </Typography>
        </Row>
        <Row center="xs" className="mt2">
          <Typography variant="body2" color="textPrimary">
            No olvides estar al pendiente de la las noficaciones.
          </Typography>
        </Row>
      </Col>
    </Row>
  );
};
